import { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { ArrowDownSVG } from '../assets/svgs';

const Select = ({
  label,
  value,
  disabled,
  options,
  showLabelAsPlaceholder,
  onChange,
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const ref = useRef();

  const handleSelectOption = (option) => {
    setShowOptions(false);
    onChange(option);
  };

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="select-input-container"
      ref={ref}
      style={{
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'all',
      }}
    >
      <button className="select-input" type="button" onClick={() => setShowOptions(!showOptions)}>
        {(!showLabelAsPlaceholder || (showLabelAsPlaceholder && value)) && <span className="select-label">{label}</span>}
        <h4 className="regular-text mb-0">{value || ((showLabelAsPlaceholder && label) || '-----')}</h4>
        <img src={ArrowDownSVG} alt="arrow-down-icon" />
      </button>
      {showOptions && (
        <div className="select-input-options-wrapper">
          <div className="select-input-options">
            {options.map((option) => (
              <button
                key={option.id}
                type="button"
                className={`text-center w-100 ${option.value === value && 'active'}`}
                onClick={() => handleSelectOption(option)}
              >
                {option.value}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

Select.defaultProps = {
  disabled: false,
  showLabelAsPlaceholder: false,
};

Select.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  showLabelAsPlaceholder: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Select;
